import { Store, select } from '@ngrx/store';
import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpResponse } from '@angular/common/http';
// import { ErrorObservable } from 'rxjs/observable/ErrorObservable';
import { Observable, throwError, combineLatest, of } from 'rxjs';
import { selectAuthToken, selectAuthLoggedIn, selectAuthSessionId } from '../features/auth/auth.selectors';
import { filter, take, catchError, map, tap } from 'rxjs/operators';
// import { AddErrorToastAction } from '../features/toaster/toaster.actions';
import { AppState } from '../reducers';
import { Router } from '@angular/router';
import { ClearStateAction } from './actions';
import { isNullOrUndefined } from 'util';
import { getSessionToken, setSessionToken } from './session.service';
import { setCookie } from './cookies.service';
import { AuthService } from '../features/auth/auth.service';
import { RefreshTokenAction, LogoutAction, GetUserAction } from '../features/auth/auth.actions';
import { Actions } from 'atlas-cdk';
import { ToastService } from '../shared/toaster_/toaster_.service';

@Injectable()
export class AuthenticationInterceptor implements HttpInterceptor {
  public logged$: Observable<boolean>;
  constructor(
    private readonly store: Store<AppState>,
    private readonly router: Router,
    private readonly _authService: AuthService,
    private readonly _toasterService: ToastService
  ) {
  }

  public intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (request.withCredentials) {
      const authToken = localStorage.getItem('auth_token') as string;
      request = request.clone({
        setHeaders: {
          Authorization: `${(!isNullOrUndefined(authToken) && authToken.indexOf('Bearer') === -1) ? 'Bearer ' + authToken : authToken}`,
          'Cache-Control': 'no-cache',
          Pragma: 'no-cache',
          // Expires: 'Sat, 01 Jan 2000 00:00:00 GMT',
        },
      });
    }

    return next.handle(request).pipe(
      tap(e => {
        if (!(e instanceof HttpResponse)) {
          return;
        }
        if (e.url && e.url.includes('/msso/token/refresh')) {
          setSessionToken(e.body.token);
          //setCookie('auth_token', e.body.token, 1);

        }
      }),
      catchError((res: Response) => this.catchErrors(res)),
    );
  }

  private catchErrors(res: Response): Observable<void> | Observable<any> {
    switch (res.status) {
      case 0:
      case 400:
        this.dispatchErrorToast('No data available!');
        break;
      case 403:
        if (this.router.url.includes('/contacts/my-connections')) {
          this.dispatchErrorToast('Page Not Found');
        } else {
          this._authService.logout();
          this.store.dispatch(new LogoutAction({
            error: true,
            message: 'You have been logged out due to inactivity',
            title: 'Session Timed Out'
          }));
        }
        break;
      case 404:
        this.dispatchErrorToast('Page Not Found');
        break;
      case 401:
        this._authService.logout();
        this.store.dispatch(new LogoutAction({
          error: true,
          message: 'You have been logged out due to inactivity',
          title: 'Session Timed Out'
        }));
        break;
      default:
        return throwError(res);
    }
  }
  private dispatchErrorToast(error?: string): void {
    if (!!error) {
      return this._toasterService.launchAlertError(error, Actions.error);
    } else {
      return this._toasterService.launchAlertError('Sorry, something went wrong.', Actions.error,
        'We have encountered an unexpected error. Please contact Technical Support team.');
    }
  }
}
